import { render, staticRenderFns } from "./InTheaters.vue?vue&type=template&id=0d0e6452&scoped=true&"
import script from "./InTheaters.vue?vue&type=script&lang=js&"
export * from "./InTheaters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0e6452",
  null
  
)

export default component.exports